import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlaskit/ufo';

export const ExperienceName: {
	readonly LOAD_PANEL: 'aiMateLoadPanel';
	readonly LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor';
	readonly LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor';
	readonly LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents';
	readonly LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent';
	readonly FETCH_CHAT: 'aiMateFetchChat';
	readonly PREFETCH_CHAT: 'aiMatePrefetchChat';
	readonly FETCH_AGENTS: 'aiMateFetchAgents';
	readonly FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated';
	readonly FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides';
	readonly FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId';
	readonly FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList';
	readonly FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId';
	readonly FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference';
	readonly FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData';
	readonly FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview';
	readonly CREATE_AGENT: 'aiMateCreateAgent';
	readonly UPDATE_AGENT: 'aiMateUpdateAgent';
	readonly DELETE_AGENT: 'aiMateDeleteAgent';
	readonly HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData';
	readonly HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata';
	readonly FAVOURITE_AGENT: 'aiMateFavouriteAgent';
	readonly UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent';
	readonly CLEAR_CHAT: 'aiMateClearChat';
	readonly SEND_MESSAGE: 'aiMateSendMessage';
	readonly SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent';
	readonly SEND_DR_MESSAGE: 'aiMateSendDRMessage';
	readonly SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage';
	readonly SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage';
	readonly RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream';
	readonly ABORT_AGENT_STREAM: 'aiMateAbortAgentStream';
	readonly ANSWER_NOW: 'aiMateAnswerNow';
	readonly HYDRATE_CONVERSATION: 'aiMateHydrateConversation';
	readonly GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels';
	readonly GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad';
	readonly UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel';
	readonly CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel';
	readonly PUBSUB_LISTENER: 'aiMatePubSubListener';
	readonly FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData';
	readonly RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction';
	readonly BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions';
	readonly MESSAGE_RENDERER: 'aiMateMessageRenderer';
	readonly FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters';
	readonly FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters';
	readonly GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters';
	readonly FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData';
	readonly FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources';
	readonly FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore';
	readonly PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore';
	readonly FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions';
	readonly CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner';
	readonly GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions';
	readonly AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent';
	readonly PREVIEW_CONTENT: 'aiMatePreviewContent';
	readonly PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender';
	readonly JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender';
	readonly JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender';
	readonly FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions';
	readonly PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions';
	readonly SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent';
	readonly FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError';
	readonly GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents';
	readonly PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents';
	readonly UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation';
	readonly VALIDATE_FILES: 'aiMateValidateFiles';
	readonly GET_CONVERSATION_FILES: 'aiMateGetConversationFiles';
	readonly AIFC_MESSAGE: 'aiMateAifcMessage';
	readonly AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal';
	readonly AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal';
	readonly AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection';
	readonly AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent';
	readonly AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat';
	readonly AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived';
	readonly AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled';
	readonly AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent';
	readonly UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat';
	readonly AIFC_MODAL_SESSION: 'aiMateAifcModalSession';
	readonly CSM_WIDGET_RENDER: 'csmWidgetRender';
	readonly CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName';
	readonly CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany';
	readonly CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone';
	readonly CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage';
	readonly CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters';
	readonly CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters';
	readonly GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState';
	readonly SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState';
	readonly AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList';
	readonly AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents';
	readonly AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList';
	readonly STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan';
	readonly MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery';
	readonly STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent';
	readonly THREADS_LIST_QUERY: 'aiMateThreadsListQuery';
	readonly WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache';
	readonly WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink';
	readonly AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions';
	readonly REMIX_START: 'aiMateRemixStart';
	readonly FETCH_PROMPTS: 'aiMateFetchPrompts';
	readonly FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus';
	readonly FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed';
	readonly REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal';
	readonly REMIX_INSERT: 'aiMateRemixInsert';
	readonly FETCH_TASKS: 'aiMateFetchTasks';
} = {
	LOAD_PANEL: 'aiMateLoadPanel',
	LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
	LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
	LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
	LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
	FETCH_CHAT: 'aiMateFetchChat',
	PREFETCH_CHAT: 'aiMatePrefetchChat',
	FETCH_AGENTS: 'aiMateFetchAgents',
	FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
	FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
	FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
	FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
	FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
	FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
	FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
	FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
	CREATE_AGENT: 'aiMateCreateAgent',
	UPDATE_AGENT: 'aiMateUpdateAgent',
	DELETE_AGENT: 'aiMateDeleteAgent',
	HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
	HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
	FAVOURITE_AGENT: 'aiMateFavouriteAgent',
	UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
	CLEAR_CHAT: 'aiMateClearChat',
	SEND_MESSAGE: 'aiMateSendMessage',
	SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
	SEND_DR_MESSAGE: 'aiMateSendDRMessage',
	SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
	SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
	RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
	ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
	ANSWER_NOW: 'aiMateAnswerNow',
	HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
	GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
	GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
	UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
	CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
	PUBSUB_LISTENER: 'aiMatePubSubListener',
	FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
	RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
	BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
	MESSAGE_RENDERER: 'aiMateMessageRenderer',
	FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
	FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
	GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
	FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
	FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
	FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
	PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
	FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
	CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
	GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
	AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
	PREVIEW_CONTENT: 'aiMatePreviewContent',
	PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
	JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
	JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
	FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
	PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
	SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
	FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
	GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
	PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
	UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
	VALIDATE_FILES: 'aiMateValidateFiles',
	GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
	AIFC_MESSAGE: 'aiMateAifcMessage',
	AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
	AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
	AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
	AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
	AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
	AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
	AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
	AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
	UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
	AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
	CSM_WIDGET_RENDER: 'csmWidgetRender',
	CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
	CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
	CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
	CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
	CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
	CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
	GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
	SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
	AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
	AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
	AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
	STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
	MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
	STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
	THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
	WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
	WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
	AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
	REMIX_START: 'aiMateRemixStart',
	FETCH_PROMPTS: 'aiMateFetchPrompts',
	FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
	FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
	REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
	REMIX_INSERT: 'aiMateRemixInsert',
	FETCH_TASKS: 'aiMateFetchTasks',
	/**
	 * If you are updating this, please do not forget to register this value in DataPortal 'attributes' tab - as the possible values for `task`. Otherwise the event will be dropped.
	 * See the guide in https://hello.atlassian.net/wiki/spaces/AA6/pages/3961393753/HOWTO+Create+FE+Reliability+SLO+using+experience+tracker
	 */
} as const satisfies {
	[key: string]: `aiMate${string}` | `csm${string}`;
};
export type ExperienceNameType = (typeof ExperienceName)[keyof typeof ExperienceName];
export enum ExperienceNamePostfix {
	MINI_MODAL = 'miniModal',
}
type SendMessageExperienceNameParams = {
	deepResearchEnabled?: boolean;
	thinkDeeperEnabled?: boolean;
	fastModeEnabled?: boolean;
	isCustomRovoAgent?: boolean;
};
export const sendMessageExperienceName = ({
	deepResearchEnabled,
	thinkDeeperEnabled,
	fastModeEnabled,
	isCustomRovoAgent,
}: SendMessageExperienceNameParams):
	| 'aiMateSendMessage'
	| 'aiMateSendMessageRovoCustomAgent'
	| 'aiMateSendDRMessage'
	| 'aiMateSendThinkDeeperMessage' => {
	if (isCustomRovoAgent) {
		return ExperienceName.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
	}

	if (deepResearchEnabled) {
		return ExperienceName.SEND_DR_MESSAGE;
	}

	if (thinkDeeperEnabled) {
		return ExperienceName.SEND_TD_MESSAGE;
	}

	if (fastModeEnabled) {
		// Sending the same experience name for fast mode as it is the same as the default (auto) mode
		return ExperienceName.SEND_MESSAGE;
	}

	return ExperienceName.SEND_MESSAGE;
};

export const AIFC_EXPERIENCES_TO_FAIL: (
	| 'aiMateAIFCFinalizeContent'
	| 'aiMateLoadStagingAreaModal'
	| 'aiMateAifcGenerateContent'
	| 'aiMateAifcGenerateContentInChat'
	| 'aiMateAifcUpdateContent'
	| 'aiMateAifcModalSession'
)[] = [
	ExperienceName.AIFC_GENERATE_CONTENT,
	ExperienceName.AIFC_GENERATE_CONTENT_IN_CHAT,
	ExperienceName.AIFC_UPDATE_CONTENT,
	ExperienceName.AIFC_FINALIZE_CONTENT,
	ExperienceName.AIFC_LOAD_STAGING_AREA_MODAL,
	ExperienceName.AIFC_MODAL_SESSION,
];

/**
 * Reasons why an experience failure was excluded from the main SLO and
 * converted to taskAbort. Used as an attribute on the aiMateFilteredClientError
 * experience so failures can be grouped/filtered by category on TOME.
 */
export const SLOExclusionReason = {
	/** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */
	CLIENT_FETCH_ERROR: 'clientFetchError',
	/** Rovo is not enabled for the user's organisation (product-not-active stream error) */
	PRODUCT_NOT_ACTIVE: 'productNotActive',
	/** User is not authenticated or lacks permission (HTTP 401/403) */
	AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError',
} as const;

export type SLOExclusionReasonType = (typeof SLOExclusionReason)[keyof typeof SLOExclusionReason];

// Note, experiences with timeouts must be listed first
export const AIFC_EXPERIENCES_TO_ABORT: (
	| 'aiMateAIFCFinalizeContent'
	| 'aiMatePreviewContent'
	| 'aiMateLoadStagingAreaModal'
	| 'aiMateAifcGenerateContent'
	| 'aiMateAifcGenerateContentInChat'
	| 'aiMateAifcInitialDataReceived'
	| 'aiMateAifcAllDataHandled'
	| 'aiMateAifcUpdateContent'
	| 'aiMateAifcModalSession'
)[] = [
	ExperienceName.AIFC_INITIAL_DATA_RECEIVED,
	ExperienceName.AIFC_ALL_DATA_HANDLED,
	ExperienceName.PREVIEW_CONTENT,
	...AIFC_EXPERIENCES_TO_FAIL,
];

// These UFO marks are used to break the experience down into different timing parts.
// backend (SUBMIT → ACTION_COMPLETE_RECEIVED) and render (ACTION_COMPLETE_RECEIVED → PREVIEW_VISIBLE) so we can see where time is being spent.
export const REMIX_GENERATE_PREVIEW_MARKS: Record<string, string> = {
	SUBMIT: 'submit',
	ACTION_COMPLETE_RECEIVED: 'action_complete_received',
	PREVIEW_VISIBLE: 'preview_visible',
};

export const REMIX_GENERATE_PREVIEW_TIMINGS: ReadonlyArray<{
	key: string;
	startMark: string;
	endMark: string;
}> = [
	{
		key: 'backend_latency',
		startMark: REMIX_GENERATE_PREVIEW_MARKS.SUBMIT,
		endMark: REMIX_GENERATE_PREVIEW_MARKS.ACTION_COMPLETE_RECEIVED,
	},
	{
		key: 'render_latency',
		startMark: REMIX_GENERATE_PREVIEW_MARKS.ACTION_COMPLETE_RECEIVED,
		endMark: REMIX_GENERATE_PREVIEW_MARKS.PREVIEW_VISIBLE,
	},
];

// UFO experience to measure e2e latency from when a user triggers a remix to when the preview is visible.
export const remixGeneratePreviewExperience: UFOExperience = new UFOExperience(
	'remix-generate-preview',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		timings: [...REMIX_GENERATE_PREVIEW_TIMINGS],
	},
);
